/* ============================================================
   SkincareLabs — shared front-end behaviour
   Loaded on every page with <script src="assets/site.js" defer>
   ============================================================ */
(function () {
  'use strict';

  /* ---- sticky add-to-cart bar ---- */
  var bar = document.getElementById('sticky');
  if (bar) {
    var anchor = document.querySelector('[data-sticky-after]');
    var threshold = anchor ? anchor.offsetHeight : 600;
    var onScroll = function () { bar.classList.toggle('on', window.scrollY > threshold); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- email capture ----
     WIRE THIS UP: replace the success branch with a POST to your ESP
     (Klaviyo /client/subscriptions, Shopify customer create, etc.). */
  var form = document.getElementById('capture-form');
  if (form) {
    var msg = document.getElementById('formmsg');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var field = form.querySelector('input[type=email]');
      var v = field.value.trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) {
        msg.textContent = 'Enter a valid email address.';
        return;
      }
      msg.textContent = 'Check your inbox — your code is on the way.';
      form.reset();
    });
  }

  /* ---- PDP quantity stepper ---- */
  Array.prototype.forEach.call(document.querySelectorAll('.qty'), function (q) {
    var input = q.querySelector('input');
    Array.prototype.forEach.call(q.querySelectorAll('button'), function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.getAttribute('data-step'), 10);
        input.value = Math.min(10, Math.max(1, (parseInt(input.value, 10) || 1) + step));
      });
    });
  });

  /* ---- PDP gallery thumbnails ---- */
  var gmain = document.querySelector('.gmain img');
  if (gmain) {
    var thumbs = document.querySelectorAll('.gthumbs button');
    Array.prototype.forEach.call(thumbs, function (b) {
      var pick = function () {
        var src = b.getAttribute('data-full');
        if (!src) return;
        // The main image has a srcset. Setting .src alone does nothing, because
        // the browser keeps resolving from the srcset candidates - which is why
        // the gallery appeared frozen, most obviously on phones where it had
        // locked onto the 600w entry. Swap srcset first, then src.
        var ss = b.getAttribute('data-srcset');
        if (ss) { gmain.srcset = ss; } else { gmain.removeAttribute('srcset'); }
        gmain.sizes = '(max-width: 900px) 92vw, 460px';
        gmain.src = src;
        gmain.alt = b.getAttribute('data-alt') || gmain.alt;
        Array.prototype.forEach.call(thumbs, function (o) {
          o.setAttribute('aria-current', o === b ? 'true' : 'false');
        });
      };
      b.addEventListener('click', pick);
      // pointer/touch devices sometimes swallow the synthetic click after a
      // scroll gesture on the strip; this makes a deliberate tap always land
      b.addEventListener('touchend', function (e) { e.preventDefault(); pick(); }, { passive: false });
    });
  }

  /* ---- gallery prev/next arrows ----
   * Built from the thumbnails rather than added to 14 templates, so the arrows
   * and the thumb strip can never disagree about how many slides exist. Each
   * arrow just triggers the neighbouring thumb, which keeps one code path for
   * selection (and one place where srcset gets swapped).
   */
  (function () {
    var stage = document.querySelector('.gmain');
    var strip = document.querySelector('.gthumbs');
    if (!stage || !strip || stage.querySelector('.gnav')) return;
    var btns = Array.prototype.slice.call(strip.querySelectorAll('button'));
    if (btns.length < 2) return;

    var idx = function () {
      for (var i = 0; i < btns.length; i++)
        if (btns[i].getAttribute('aria-current') === 'true') return i;
      return 0;
    };
    var go = function (step) {
      var n = (idx() + step + btns.length) % btns.length;   // wraps both ways
      btns[n].click();
      btns[n].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    };
    var make = function (dir, label, d) {
      var a = document.createElement('button');
      a.type = 'button';
      a.className = 'gnav gnav-' + dir;
      a.setAttribute('aria-label', label);
      a.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + d + '"/></svg>';
      a.addEventListener('click', function (e) { e.preventDefault(); go(dir === 'prev' ? -1 : 1); });
      stage.appendChild(a);
      return a;
    };
    make('prev', 'Previous image', 'M15 4 7 12l8 8');
    make('next', 'Next image',     'M9 4l8 8-8 8');

    // keyboard support once the gallery has focus
    stage.setAttribute('tabindex', '0');
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); go(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    });
  })();

  /* ---- collection filters ---- */
  var filters = document.querySelectorAll('.filterbar button');
  if (filters.length) {
    Array.prototype.forEach.call(filters, function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-filter');
        Array.prototype.forEach.call(filters, function (o) {
          o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
        });
        Array.prototype.forEach.call(document.querySelectorAll('.collgrid .card'), function (c) {
          var tags = (c.getAttribute('data-tags') || '').split(' ');
          c.hidden = !(f === 'all' || tags.indexOf(f) > -1);
        });
      });
    });
  }
})();

/* ---------- mobile navigation ----------
 * Built from the existing .navlinks rather than duplicated into every page's
 * markup, so the desktop menu and the mobile menu can never drift apart.
 * Below 1000px .navlinks is display:none, which previously left phones and
 * tablets with no navigation at all.
 */
(function () {
  var nav = document.querySelector('nav .navin');
  var links = document.querySelector('nav .navlinks');
  if (!nav || !links || document.querySelector('.navtoggle')) return;

  var brand = nav.querySelector('.brand');
  var cart = nav.querySelector('.cart');

  var toggle = document.createElement('button');
  toggle.className = 'navtoggle';
  toggle.type = 'button';
  toggle.setAttribute('aria-label', 'Menu');
  toggle.setAttribute('aria-expanded', 'false');
  toggle.innerHTML = '<span></span><span></span><span></span>';
  nav.appendChild(toggle);

  var overlay = document.createElement('div');
  overlay.className = 'navpanel-overlay';
  var panel = document.createElement('aside');
  panel.className = 'navpanel';
  panel.setAttribute('aria-label', 'Menu');
  panel.innerHTML =
    '<div class="ptop">'
    + '<span class="brand">' + (brand ? brand.textContent : 'SkincareLabs') + '</span>'
    + '<button type="button" class="pclose" aria-label="Close menu">&times;</button>'
    + '</div>'
    + '<ul>' + links.innerHTML + '</ul>'
    + (cart ? '<div class="pcart"><a href="' + cart.getAttribute('href') + '">' + cart.textContent + '</a></div>' : '');
  document.body.appendChild(overlay);
  document.body.appendChild(panel);

  function open() {
    // reflow before the class so the transition runs even in a background tab
    void panel.offsetHeight;
    panel.classList.add('open');
    overlay.classList.add('open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    panel.classList.remove('open');
    overlay.classList.remove('open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', function () {
    panel.classList.contains('open') ? close() : open();
  });
  overlay.addEventListener('click', close);
  panel.querySelector('.pclose').addEventListener('click', close);
  panel.addEventListener('click', function (e) { if (e.target.closest('a')) close(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('open')) close();
  });
  // returning to desktop width must not leave the panel stranded open
  window.addEventListener('resize', function () {
    if (window.innerWidth > 1000 && panel.classList.contains('open')) close();
  });
})();
